export default __webpack_public_path__ + "static/media/login.b0f8c3c3.jpg";